<script>
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";

export default {
  page: {
    title: "SignupSelector",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {};
  },
};
</script>

<template>
  <Layout>
    <section class="signup-selector">
      <div class="signup">
        <div class="header">
          <div class="logo">
            <img
              src="@/assets/images/logo-lg.svg"
              class="unselectable mx-auto"
              alt
              width="88px"
              height="16px"
            />
          </div>
          <div class="subtitle">
            <span>Register</span>
          </div>

        </div>
        <div class="content">
          <div class="item" @click="$router.push('/register-passport')">
            <div class="info">
              <div class="item-icon-wrapper">
                <img
                  src="@/assets/images/passport-register.svg"
                  class="item-icon passport-icon"
                  alt
                />
              </div>
              <div>
                <p class="item-title">{{ $t('common.visiPointPassport')}}</p>
                <p class="item-subtitle">
                  Get a QuickPass QR code for speedy check-in at any VisiPoint location.
                </p>
              </div>
            </div>
            <div class="icon-wrapper">
              <i class="mdi mdi-chevron-right redirect-icon"></i>
            </div>
          </div>
          <hr class="hr-line" />
          <div class="item dashboard-info" @click="$router.push('/register')">
            <div class="info">
              <div class="item-icon-wrapper ">
                <img
                  src="@/assets/images/dashboard-register.svg"
                  class="item-icon dashboard-icon"
                  alt
                />
              </div>
              <div>
                <p class="item-title">{{ $t('form.companyDashboard')}}</p>
                <p class="item-subtitle">
                  Create your company dashboard and get VisiPoint Passport with a QuickPass QR code.
                </p>
              </div>
            </div>
            <div class="icon-wrapper">
              <i class="mdi mdi-chevron-right redirect-icon"></i>
            </div>
          </div>
        </div>
        <div class="login-btn-section">
          <p class="margin-subtitle">{{ $t('form.alreadyHaveAccount')}}</p>
          <div class="login-btn">
            <router-link to="/login" class="redirect-login-btn">{{ $t('common.login').toUpperCase()}}</router-link>
          </div>
        </div>
      </div>
    </section>
  </Layout>
</template>


<style lang="scss" scoped>

.signup-selector {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .signup {
    width: 500px !important;
    .header {
      text-align: center;
      background: #ffffff;
      border-radius: 26px;
      padding-top: 24px;
      padding-bottom: 24px;
      margin-bottom: 16px;
      .logo {
        margin-bottom: 20px;
      }
      .subtitle {
        font-weight: 500;
        font-size: 16px;
        color: #4A4A4A;
      }
    }
    .content {
      background-color: #fff;
      border-radius: 26px;
      padding: 40px 40px;
      margin-bottom: 16px;
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        .info {
          display: flex;
          
          .item-icon-wrapper {
            margin-right: 24px;
            img {
              max-width: 100px;
            }
          }
          .passport-icon {
            width: 28px !important;  
            height: 40px !important;          
          }
          .dashboard-icon {
            width: 28px !important;
            height: 28px !important;
          }
          .item-title {
            width: 319px;
            font-weight: 700;
            font-size: 18px;
            text-transform: uppercase;
            color: #000000;
            font-family: Lato;
            letter-spacing: 0.25px;
          }
          .item-subtitle {
            font-weight: 500;
            font-size: 14px;
            color: #787878;
            font-family: Lato;
            line-height: 22px;
            letter-spacing: 0%;
            vertical-align: middle;
            margin-bottom: 0px !important;
          }

        }
        .redirect-icon {
          color: #000;
          font-size: 33px;
          cursor: pointer;
          transition: 0.3s;
          &:hover {
            color: #103f5e;
          }
        }
      }
      .hr-line {
        margin-bottom: 32px !important;
        margin-top: 32px !important;
      }
      .dashboard-info {
        margin-bottom: 0 !important;
      }
    }
    .login-btn-section {
      @extend .header;
      .margin-subtitle {
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: 0%;
        text-align: center;
        color : #787878
      }
      .login-btn {

        line-height: 100%;
        letter-spacing: 0%;
        text-align: center;
        text-transform: uppercase;

        .redirect-login-btn{
          color: #103F5E !important;
          font-size: 16px;
          font-weight: 700 !important;
          color: #103F5E !important;
          font-family: Lato;
          font-weight: 700;
        }
      }
    }
  }
}
</style>
